import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { SPONSOR_STAGES } from "./eventosUtils";
import { PakkeVelger } from "./PakkeVelger";

export default function NyPartnerModal({ companies, onLagre, onLukk }) {
  const [companyId, setCompanyId] = useState("");
  const [form, setForm] = useState({ name: "", contactName: "", contactEmail: "", packageName: "", value: 0, stage: "researching" });
  const [lagrer, setLagrer] = useState(false);

  useEffect(() => {
    const esc = (e) => { if (e.key === "Escape") onLukk(); };
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onLukk]);

  const sett = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const gyldig = companyId || form.name.trim();

  const lagre = async () => {
    if (!gyldig || lagrer) return;
    setLagrer(true);
    try {
      await onLagre({ ...form, value: Number(form.value) || 0, companyId: companyId || null });
    } finally {
      setLagrer(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-[10vh] px-4" data-testid="ny-partner-modal">
      <div className="sak-backdrop absolute inset-0 bg-black/25" onClick={onLukk} />
      <div className="sak-modal relative w-full max-w-[480px] bg-white rounded-2xl shadow-2xl border border-[#E7E4DB] p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-[15px] font-semibold">Ny partner</h2>
          <button type="button" onClick={onLukk} className="text-neutral-400 hover:text-neutral-800 transition-colors" data-testid="ny-partner-lukk">
            <X size={16} />
          </button>
        </div>
        <label className="adm-label">
          Eksisterende selskap
          <select value={companyId} onChange={(e) => setCompanyId(e.target.value)} className="adm-input" data-testid="ny-partner-selskap-select">
            <option value="">Nytt selskap …</option>
            {(companies || []).map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </label>
        {!companyId && (
          <div className="grid grid-cols-2 gap-3 mt-3">
            <label className="adm-label col-span-2">
              Selskapsnavn *
              <input value={form.name} onChange={(e) => sett("name", e.target.value)} className="adm-input" autoFocus data-testid="ny-partner-navn-input" />
            </label>
            <label className="adm-label">
              Kontaktperson
              <input value={form.contactName} onChange={(e) => sett("contactName", e.target.value)} className="adm-input" data-testid="ny-partner-kontakt-input" />
            </label>
            <label className="adm-label">
              E-post
              <input value={form.contactEmail} onChange={(e) => sett("contactEmail", e.target.value)} className="adm-input" data-testid="ny-partner-epost-input" />
            </label>
          </div>
        )}
        <div className="grid grid-cols-3 gap-3 mt-3">
          <PakkeVelger verdi={form.packageName} onVelg={(v) => sett("packageName", v)} testid="ny-partner-pakke-input" />
          <label className="adm-label">
            Verdi eks. mva
            <input type="number" value={form.value} onChange={(e) => sett("value", e.target.value)} className="adm-input" data-testid="ny-partner-verdi-input" />
          </label>
          <label className="adm-label">
            Stadium
            <select value={form.stage} onChange={(e) => sett("stage", e.target.value)} className="adm-input" data-testid="ny-partner-stage-select">
              {SPONSOR_STAGES.filter((s) => s.k !== "declined").map((s) => (
                <option key={s.k} value={s.k}>{s.label}</option>
              ))}
            </select>
          </label>
        </div>
        <div className="flex items-center justify-end gap-2 mt-5">
          <button type="button" onClick={onLukk} className="adm-btn-ghost">Avbryt</button>
          <button type="button" onClick={lagre} disabled={!gyldig || lagrer} className="adm-btn" data-testid="ny-partner-lagre-btn">
            {lagrer ? "Lagrer …" : "Legg til"}
          </button>
        </div>
      </div>
    </div>
  );
}
